import { post } from '../../helpers/securityService';

import { OpenEye } from './openeye';
import { Envysion } from './envysion';
import { Solink } from './solink';
import { Itech } from './itech';
import { Lemon } from './lemon';
import { Wachter } from './wachter';
import { DTIQ } from './dtiq';
import { IPConfigure } from './ipconfigure';
import { reactive } from 'vue';

// factory fn to create camera class based on the className
const providerToclass = {
  UAS: OpenEye,
  'Shore Systems': OpenEye,
  'Itech Digital': OpenEye,
  Envysion,
  Solink,
  ITECH: Itech,
  lemon: Lemon,
  wachter: Wachter,
  DTIQ,
  ipconfigure: IPConfigure,
};
export function createCameraInstance(cameraProvider, camera, orgId, userId) {
  if (providerToclass[cameraProvider])
    return reactive(new providerToclass[cameraProvider](camera, orgId, userId));
  return null;
}

// tells us if the camera vendor is supported
const supportedCameraVendors = Object.keys(providerToclass);

export function isCameraVendorSupported(camProvider) {
  const isSupported = supportedCameraVendors.includes(camProvider);
  return isSupported;
}

export async function loadCameraPending(location, orgId) {
  const url = `security/video_provider/${location}`;
  const response = await post(url, {}, { orgId });
  if (response === "This nsn has no camera provider.") {
    return response;
  }
  const cameraObj = response.payload?.video;
  if (!cameraObj) throw Error('Camera not supported');
  cameraObj.location = location;
  return cameraObj;
}
